/*
Copyright 2022 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/
import { css } from '@spectrum-web-components/base';
const styles = css`
.spectrum-Code{font-family:var(
--spectrum-heading-m-text-font-family,var(--spectrum-alias-body-text-font-family)
)}.spectrum-Code .spectrum-Code-strong,.spectrum-Code strong{font-weight:var(
--spectrum-code-m-strong-text-font-weight,var(--spectrum-global-font-weight-bold)
)}.spectrum-Code .spectrum-Code-emphasized,.spectrum-Code em{font-style:var(
--spectrum-code-m-emphasized-text-font-style,var(--spectrum-global-font-style-italic)
)}.spectrum-Code--serif{font-family:var(
--spectrum-body-m-serif-text-font-family,var(--spectrum-alias-serif-text-font-family)
)}.spectrum-Code--sizeXL{font-family:var(
--spectrum-code-xl-text-font-family,var(--spectrum-alias-code-text-font-family)
);font-size:var(
--spectrum-code-xl-text-size,var(--spectrum-global-dimension-font-size-400)
);font-style:var(
--spectrum-code-xl-text-font-style,var(--spectrum-global-font-style-regular)
);font-weight:var(
--spectrum-code-xl-text-font-weight,var(--spectrum-alias-code-text-font-weight-regular)
);letter-spacing:var(
--spectrum-code-xl-text-letter-spacing,var(--spectrum-global-font-letter-spacing-none)
);line-height:var(
--spectrum-code-xl-text-line-height,var(--spectrum-alias-body-text-line-height)
);margin-bottom:0;margin-top:0}.spectrum-Code--sizeL{font-family:var(
--spectrum-code-l-text-font-family,var(--spectrum-alias-code-text-font-family)
);font-size:var(
--spectrum-code-l-text-size,var(--spectrum-global-dimension-font-size-300)
);font-style:var(
--spectrum-code-l-text-font-style,var(--spectrum-global-font-style-regular)
);font-weight:var(
--spectrum-code-l-text-font-weight,var(--spectrum-alias-code-text-font-weight-regular)
);letter-spacing:var(
--spectrum-code-l-text-letter-spacing,var(--spectrum-global-font-letter-spacing-none)
);line-height:var(
--spectrum-code-l-text-line-height,var(--spectrum-alias-body-text-line-height)
);margin-bottom:0;margin-top:0}.spectrum-Code--sizeM{font-family:var(
--spectrum-code-m-text-font-family,var(--spectrum-alias-code-text-font-family)
);font-size:var(
--spectrum-code-m-text-size,var(--spectrum-global-dimension-font-size-200)
);font-style:var(
--spectrum-code-m-text-font-style,var(--spectrum-global-font-style-regular)
);font-weight:var(
--spectrum-code-m-text-font-weight,var(--spectrum-alias-code-text-font-weight-regular)
);letter-spacing:var(
--spectrum-code-m-text-letter-spacing,var(--spectrum-global-font-letter-spacing-none)
);line-height:var(
--spectrum-code-m-text-line-height,var(--spectrum-alias-body-text-line-height)
);margin-bottom:0;margin-top:0}.spectrum-Code--sizeS{font-family:var(
--spectrum-code-s-text-font-family,var(--spectrum-alias-code-text-font-family)
);font-size:var(
--spectrum-code-s-text-size,var(--spectrum-global-dimension-font-size-100)
);font-style:var(
--spectrum-code-s-text-font-style,var(--spectrum-global-font-style-regular)
);font-weight:var(
--spectrum-code-s-text-font-weight,var(--spectrum-alias-code-text-font-weight-regular)
);letter-spacing:var(
--spectrum-code-s-text-letter-spacing,var(--spectrum-global-font-letter-spacing-none)
);line-height:var(
--spectrum-code-s-text-line-height,var(--spectrum-alias-body-text-line-height)
);margin-bottom:0;margin-top:0}.spectrum-Code--sizeXS{font-family:var(
--spectrum-code-xs-text-font-family,var(--spectrum-alias-code-text-font-family)
);font-size:var(
--spectrum-code-xs-text-size,var(--spectrum-global-dimension-font-size-75)
);font-style:var(
--spectrum-code-xs-text-font-style,var(--spectrum-global-font-style-regular)
);font-weight:var(
--spectrum-code-xs-text-font-weight,var(--spectrum-alias-code-text-font-weight-regular)
);letter-spacing:var(
--spectrum-code-xs-text-letter-spacing,var(--spectrum-global-font-letter-spacing-none)
);line-height:var(
--spectrum-code-xs-text-line-height,var(--spectrum-alias-body-text-line-height)
);margin-bottom:0;margin-top:0}.spectrum-Code--sizeXL{color:var(
--spectrum-code-xl-text-color,var(--spectrum-alias-text-color)
)}.spectrum-Code--sizeL{color:var(
--spectrum-code-l-text-color,var(--spectrum-alias-text-color)
)}.spectrum-Code--sizeM{color:var(
--spectrum-code-m-text-color,var(--spectrum-alias-text-color)
)}.spectrum-Code--sizeS{color:var(
--spectrum-code-s-text-color,var(--spectrum-alias-text-color)
)}.spectrum-Code--sizeXS{color:var(
--spectrum-code-xs-text-color,var(--spectrum-alias-text-color)
)}
`;
export default styles;